// 首页列表组件 特殊样式，好评飙升什么鬼的排行榜样式
import * as React from 'react'
import HomeType from '../../types/HomeType'
import HomeItemTag from './HomeItemTag'
import * as Styles from './HomeFavourableRoll.style'
import { deletePictureParams, renderPopular } from '../../../../utils/tools'
import { classes } from 'typestyle'
import { ImageView } from '../ImageView/ImageView'
import { ViewingMonitor, reAssemblyUbt, reportClickEvent } from '@weike/operation-report'
import { reportSetUbt } from '../../../../services/Modules/reportServer'
// tslint:disable-next-line

interface HomeLimitBarProp {
  content: HomeType.Content
  topMargin?: number
  bottomMargin?: number
  feed?: number
  feedName?: string
  index: number
  isLastIndex: boolean
}

const ImageConfig = {
  1: require(`./images/no_1.png`),
  2: require(`./images/no_2.png`),
  3: require(`./images/no_3.png`),
  4: require(`./images/no_4.png`)
}

/** 好评样式，大item */
export function FirstModule(props: HomeLimitBarProp, index: number) {
  const { content } = props
  const getDistance = {
    paddingTop: props.topMargin ? props.topMargin : '',
    paddingBottom: props.bottomMargin ? props.bottomMargin : ''
  }
  const gotoLink = (url: string) => {
    console.log('gotoLink', url)
    reportClickEvent(`feed__${props.feed}`, {
      index: props.index,
      url: props.content.url,
      context: props.feedName,
      ch_id: props.content.id
    })
    // HACK: add ubt
    const getUbt = reportSetUbt(`feed__${props.feed}`)
    // console.log(getUbt, `${url}&${getUbt}`, props)
    setTimeout(() => {
      window.location.href = `${url}&${getUbt}`
    }, 150)
  }
  return (
    <ViewingMonitor
      ubt={reAssemblyUbt(`feed__${props.feed}`)}
      params={{
        index: props.index,
        url: props.content.url,
        context: props.feedName,
        ch_id: props.content.id
      }}
    >
      <div className={Styles.FavouriteIndexOne}>
        <a
          style={getDistance}
          className={Styles.HomeItemListItemSpecial}
          onClick={() => gotoLink(content.stype === 'coupon' ? content.url + `&${content.meta.params}` : content.url)}
        >
          <div className={Styles.HomeItemBigBgImage}>
            {window.location.pathname !== '/category' ? (
              <ImageView url={content.cover_url ? content.cover_url : content.cover} width={600} />
            ) : (
              <picture>
                <source
                  type="image/webp"
                  srcSet={
                    content.cover_url
                      ? `${deletePictureParams(content.cover_url)}?imageView2/format/webp/2/w/600/q/85!`
                      : `${deletePictureParams(content.cover)}?imageView2/format/webp/2/w/600/q/85!`
                  }
                />
                <img
                  src={content.cover_url ? `${deletePictureParams(content.cover_url)}?imageView2/2/w/600/q/85!` : `${deletePictureParams(content.cover)}?imageView2/2/w/600/q/85!`}
                  alt=""
                />
              </picture>
            )}
          </div>

          <div className={Styles.BottomTitleWrap}>
            <div className={Styles.title}>
              <div className={'TextChangeToTwoLines'}>{content.name ? content.name : content.title}</div>
            </div>

            <div className={Styles.rightWrap}>
              {props.index + 1 <= 4 && <img className={Styles.NumImg} src={ImageConfig[index + 1]} alt="" />}
              <div className={Styles.popular}>
                <img src="https://static-cos.lycheer.net/picture/12209467_430d72d8d6caec8c9b370df1c5e412b9.jpg" alt="" />
                <span>{content.tag}</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </ViewingMonitor>
  )
}

function HomeFavourableRoll(props: HomeLimitBarProp) {
  //   console.log('HomeFavourableRoll', props)
  const content = props.content
  const getDistance = {
    paddingTop: props.topMargin ? props.topMargin : '',
    paddingBottom: props.bottomMargin ? props.bottomMargin : ''
  }

  const renderLectureTag = () => {
    if (content.lecture_mode === 'default') {
      switch (content.image_mode) {
        case 'video':
          return <HomeItemTag text={'视频'} />
        case 'audio':
          return <HomeItemTag text={'音频'} />
        case 'ppt':
          return <HomeItemTag text={'PPT'} />
        default:
          return true
      }
    } else {
      switch (content.lecture_mode) {
        case 'video':
          return <HomeItemTag text={'视频'} />
        case 'audio':
          return <HomeItemTag text={'音频'} />
        default:
          return true
      }
    }
  }

  const renderPrice = () => {
    if (content.stype === 'coupon') {
      return (
        <div className={Styles.couponTagSm}>
          <div className={Styles.couponTagSmText}>立减{content.meta && content.meta.desc}元</div>
        </div>
      )
    }
    if (content.need_money) {
      if (content.has_limitmoney) {
        if (Number(content.limit_money) === 0) {
          return (
            <p>
              <span>限时免费</span>
            </p>
          )
        } else {
          // tslint:disable-next-line
          return (
            <p>
              <i style={{ fontStyle: 'normal', fontSize: 12 }}>￥</i>
              {content.limit_money.split('.')[0]}
              <span>.{content.limit_money.split('.')[1]}</span>
            </p>
          )
        }
      } else {
        // tslint:disable-next-line
        return (
          <p>
            <i style={{ fontStyle: 'normal', fontSize: 12 }}>￥</i>
            {content.lecture_money.split('.')[0]}
            <span>.{content.lecture_money.split('.')[1]}</span>
          </p>
        )
      }
    } else {
      if (content.lecture_type !== 'pay_channel') {
        return <span className={Styles.HomeItemRightFreeLecture}>免费</span>
      } else {
        return null
      }
    }
  }

  const renderLectureTime = () => {
    if (content.lecture_mode === 'video' || content.lecture_mode === 'audio') {
      return (
        <p>
          时长<span>{content.audio_length}</span>分钟
        </p>
      )
    }

    if (content.status === 'closed') {
      if (content.audio_length <= 5) {
        return <p>{content.start_time.split(' ')[0]}</p>
      } else {
        return (
          <p>
            时长<span>{content.audio_length}</span>分钟
          </p>
        )
      }
    } else {
      return <p>{content.status_name}</p>
    }
  }

  const ifIsLivingStatus = () => {
    if (content.start_name === '正在直播') {
      return true
    } else {
      return false
    }
  }

  const gotoLink = (url: string) => {
    reportClickEvent(`feed__${props.feed}`, {
      index: props.index,
      url: props.content.url,
      context: props.feedName,
      ch_id: props.content.id
    })
    // HACK: add ubt
    const getUbt = reportSetUbt(`feed__${props.feed}`)
    // console.log(getUbt, `${url}&${getUbt}`, props)
    setTimeout(() => {
      window.location.href = `${url}&${getUbt}`
    }, 150)
  }

  return (
    <ViewingMonitor
      ubt={reAssemblyUbt(`feed__${props.feed}`)}
      params={{
        index: props.index,
        url: props.content.url,
        context: props.feedName,
        ch_id: props.content.id
      }}
    >
      <div>
        {props.index === 0 && FirstModule(props, props.index)}
        {props.index > 0 && (
          <a
            style={getDistance}
            className={classes(Styles.HomeItemListItem, props.isLastIndex ? '' : Styles.HomeItemLastItem)}
            onClick={() => gotoLink(content.stype === 'coupon' ? content.url + `&${content.meta.params}` : content.url)}
          >
            <div className={Styles.HomeItemLeft}>
              {props.index + 1 <= 4 && <img className={Styles.NoPicStle} src={ImageConfig[props.index + 1]} />}
              <div className={Styles.HomeItemLeftBgImage}>
                {window.location.pathname !== '/category' ? (
                  <ImageView url={content.cover_url ? content.cover_url : content.cover} width={300} />
                ) : (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet={
                        content.cover_url
                          ? `${deletePictureParams(content.cover_url)}?imageView2/format/webp/2/w/300/q/85!`
                          : `${deletePictureParams(content.cover)}?imageView2/format/webp/2/w/300/q/85!`
                      }
                    />
                    <img
                      src={
                        content.cover_url ? `${deletePictureParams(content.cover_url)}?imageView2/2/w/300/q/85!` : `${deletePictureParams(content.cover)}?imageView2/2/w/300/q/85!`}
                      alt=""
                    />
                  </picture>
                )}
              </div>

              {/* <div className={Styles.StudyTotalNum}>
                    <div className={Styles.StudyTotalNumDiv}>
                        <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                        {renderPopular(content.popular)}人
                    </div>
                </div> */}
              {content.stype === 'coupon' && (
                <div>
                  <div className={Styles.couponTagBig} />
                  <div className={Styles.couponTagBigText}>
                    <p>立减</p>
                    <p>
                      <span>{content.meta && content.meta.desc}</span>
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className={Styles.HomeItemRight}>
              <div className={classes(Styles.HomeItemRightTitle, 'TextChangeToTwoLines')}>
                {content.is_preffered && (
                  <div className={Styles.youXuanType}>
                    <img src="https://static-cos.lycheer.net/picture/10490565_2851c8d7884e28dd13a5119f3f0afe89.jpg" alt="" />
                  </div>
                )}
                {content.type && content.type === 'lecture' && !content.is_preffered && renderLectureTag()}
                {content.name ? content.name : content.title}
              </div>

              <div className={Styles.HomeItemLeftBottom}>
                <div className={Styles.Normalpopular}>
                  <img src="https://static-cos.lycheer.net/picture/12209467_430d72d8d6caec8c9b370df1c5e412b9.jpg" alt="" />
                  <span>{content.tag}</span>
                </div>
                {/* <div className="currency-item-right-bottom_left-count-time" style={{color: '#999999'}}>
                        {content.type && content.type === 'channel' && !ifIsLivingStatus() &&
                            <p>已更新<span>{content.current_status_display.replace('已更新', '').replace('期', '').replace('节课程', '').replace('含', '')}</span>期</p>
                        }
                        {(content.type && content.type === 'lecture') && !ifIsLivingStatus() &&
                            renderLectureTime()
                        }
                        {ifIsLivingStatus() &&
                        <div className="HomeItemLeftBottom">
                            <div className={Styles.isLivingText}>
                                <img className={Styles.LiveStatusImg} src="https://static-cos.lycheer.net/picture/7931794_e27bd04f8061e533ae1851e0928b2f50.jpg" alt=""/>
                            正在直播
                            </div>
                        </div>
                        }
                    </div> */}

                <div className={Styles.HomeItemRightBotton}>
                  {content.type && content.type === 'lecture' && (
                    <div className={Styles.HomeItemRightBottonRight}>
                      {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' && (
                        <p className="HomeItemRightBottonRightLimit">
                          <del>￥{content.lecture_money}</del>
                        </p>
                      )}
                      {renderPrice()}
                    </div>
                  )}
                  {content.type && content.type === 'channel' && (
                    <div className={Styles.HomeItemRightBottonRight}>
                      {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' && (
                        <p className="HomeItemRightBottonRightLimit">
                          <del>￥{content.lecture_money}</del>
                        </p>
                      )}
                      {renderPrice()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </a>
        )}
      </div>
    </ViewingMonitor>
  )
}

export default HomeFavourableRoll



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeFavourableRoll/HomeFavourableRoll.tsx